﻿import {Howl} from 'howler';
import {Core} from "./Core";

class SoundPool {
    maxSize = 5;
    items = new Map();

    constructor(url, options = {}) {
        this.url = url;
        this.options = options;

        Core.LocalSettings.on("SettingsChanged", () => {
            for (let sound of this.items.values()) {
                sound.mute(!Core.LocalSettings.Sound);
            }
        });
    }

    play() {

        if (!Core.LocalSettings.Sound) return;

        for (let [id, item] of this.items.entries()) {
            if (!item.playing(id)) return item.play(id);
        }

        if (this.items.size >= this.maxSize) return;

        let item = new Howl({
            src: [this.url],
            // html5: true,
            ...this.options
        });
        let id = item.play();
        this.items.set(id, item);
        return id;
    }

    stop() {
        for (let [id, item] of this.items.entries()) {
            item.stop(id);
        }
    }

    unload() {
        for (let [id, item] of this.items.entries()) {
            item.unload(id);
        }
        this.items.clear();
    }
}

export class AudioManager {

    music = null;
    sounds = new Map();

    Init() {
        this.onSettingsChanged = this.onSettingsChanged.bind(this);

        let keys = [...Object.keys(Core.app.loader.resources)].filter(key => key.startsWith('sounds/'));
        for (let key of keys) {
            let name = key.replace('sounds/', '');
            let url = Core.app.loader.resources[key].url;
            this.sounds.set(name, new SoundPool(url));
        }

        this.music = new Howl({
            src: [Core.app.loader.resources["music/Music"].url],
            // html5: true,
            volume: 0.5,
            loop: true,
            onplayerror: () => {
                this.music.once('unlock', () => this.music.play());
            }
        });

        Core.LocalSettings.on("SettingsChanged", this.onSettingsChanged);
        this.onSettingsChanged();
    }

    SetMuted(value) {
        Howler.mute(!!value);
    }

    Play(name) {
        let sound = this.sounds.get(name);
        if (sound) {
            sound.play();
        }
    }

    onSettingsChanged() {
        if (!Core.LocalSettings) return;
        this.music.mute(!Core.LocalSettings.Music);
    }

    PlayLobbyTheme() {
        if (!this.music.playing()) {
            this.music.soundId = this.music.play(this.music.soundId);
        }
    }

    Reset(){
        this.Destroy();
    }

    Destroy() {
        if (this.music) {
            this.music.unload();
        }
        this.music = null;
        for (let sound of this.sounds.values()) {
            if (sound) sound.unload();
        }
        this.sounds.clear();
    }
}
